import ValidationType from '../ValidationType';
import { datesAreEqual, dateIsBefore } from "../../dateutil";
import moment from 'moment-timezone';

class BeforeDateTimeEx extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      const current = moment(fieldResponse.currentValue).utcOffset(moment(fieldResponse.currentValue).utcOffset() ).format('YYYY-MM-DD h:mm a');
      const compare = moment(validation.value).utcOffset(moment(validation.value).utcOffset()).format('YYYY-MM-DD  h:mm a');
      if ( !dateIsBefore(current, compare)) {
        const error = this.createValidationError({
          fieldResponse,
          key: 'ERROR_BEFORE_SPECIFIED_DATE_EX',
          values: { value: validation.value },
          message: `Value should be before '${compare}'`,
        });
        errors.push(error);
      }
    }
    return errors;
  }
}

export default BeforeDateTimeEx;
